module.exports = __webpack_public_path__ + "img/default-img2.8c681342.png";